import type {
  CheckboxGroupProps as ChakraCheckboxGroupProps
} from '@chakra-ui/react'
import {
  forwardRef
} from '@chakra-ui/react'
import { Controller, useFormContext } from 'BrokerTsLib/src/rhf'
import React from 'react'

import { CompanyCheckboxGroup as CustomCompanyCheckboxGroup } from './company-checkbox/checkbox-group'

export interface CompanyCheckboxGroupProps extends ChakraCheckboxGroupProps {
  children: React.ReactNode
  name: string
  onChange?: (value: string[]) => void
}

export const CompanyCheckboxGroup = forwardRef(({ children, name, ...rest }: CompanyCheckboxGroupProps, ref) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <CustomCompanyCheckboxGroup
          onChange={(insurers) => onChange(insurers.map(i => parseInt(i.toString())))}
          value={value}
          {...rest}
        >
          {children}
        </CustomCompanyCheckboxGroup >
      )}
    />
  )
},
)
